import { render, staticRenderFns } from "./Thumb1.vue?vue&type=template&id=054a80a2"
import script from "./Thumb1.vue?vue&type=script&lang=js"
export * from "./Thumb1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports